module.exports = __webpack_public_path__ + "img/michael.4b404858.webp";